module.exports = __webpack_public_path__ + "images/emoji/ocean.8ffb4b225d36f3af1fac.png";